import styled from 'styled-components'
import { List as ListMUI } from '@mui/material'

export const List = styled(ListMUI)`
  background-color: #fff;
  width: 330px;
`
